export default __webpack_public_path__ + "static/media/ProductsList_img5_Hk.de4318a1.webp";